import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormGenerator, ModalWrapper } from '@microservices/wiskey-react-components'
import { Box } from '@mui/material'

import { GENERATOR_INPUT_TYPE } from '@constants'
import { CopyControlPanelPayload } from '@types'

type CopyDialogProps = {
  onClose: () => void
  copyData: CopyControlPanelPayload
  onCopy: (data: CopyControlPanelPayload) => void
  dialogTitle: string
  loading?: boolean
}

export const CopyDialog = ({
  onClose,
  copyData,
  onCopy,
  dialogTitle,
  loading,
}: CopyDialogProps) => {
  const methods = useForm<CopyControlPanelPayload>()
  const { t } = useTranslation()

  const {
    handleSubmit,
    reset,
    formState: { isDirty },
  } = methods

  useEffect(() => {
    reset(copyData)
  }, [copyData])

  const handleSave = (formValue: CopyControlPanelPayload) => {
    onCopy(formValue)
  }

  const handleClose = () => {
    if (isDirty && !confirm(t('notifications.leave'))) {
      return
    }

    onClose()
  }

  return (
    <ModalWrapper
      disabledSave={loading}
      isShow={true}
      title={dialogTitle}
      containerStyle={{
        px: 0.5,
        py: 0.5,
        // borderRadius: 0
      }}
      onClose={handleClose}
      onSave={handleSubmit(handleSave)}
    >
      <Box my={1}>
        <FormProvider {...methods}>
          <FormGenerator
            mainGridSpacing={0}
            inputs={[
              {
                name: 'title',
                inputType: GENERATOR_INPUT_TYPE.INPUT,
                label: t('copying.inputs.title.label'),
                placeholder: t('copying.inputs.title.placeholder'),
                rules: { required: true },
              },
            ]}
          />
        </FormProvider>
      </Box>
    </ModalWrapper>
  )
}
